import React, { useState, useEffect } from 'react';
import LoginScreen from './LoginScreen';

function decodeToken(token) {
  try {
    const dataB64 = token.split('.')[0];
    // base64url → base64
    const base64 = dataB64.replace(/-/g, '+').replace(/_/g, '/');
    return JSON.parse(atob(base64));
  } catch {
    return null;
  }
}

function isExpired(payload) {
  if (!payload) return true;
  if (payload.role === 'owner') return false; // owner never expires
  if (!payload.expiresAt) return false;       // no expiry set
  return new Date(payload.expiresAt) < new Date();
}

function clearSession() {
  sessionStorage.removeItem('auth_token');
  sessionStorage.removeItem('auth_role');
}

const AuthGate = ({ children }) => {
  const [auth, setAuth] = useState(null); // null = checking, false = not authed, { role } = authed

  useEffect(() => {
    const token = sessionStorage.getItem('auth_token');
    const role = sessionStorage.getItem('auth_role');

    if (!token || !role) {
      setAuth(false);
      return;
    }

    const payload = decodeToken(token);
    if (isExpired(payload)) {
      clearSession();
      setAuth(false);
      return;
    }

    setAuth({ role });

    // Check every minute if the session has expired
    const interval = setInterval(() => {
      const t = sessionStorage.getItem('auth_token');
      if (!t || isExpired(decodeToken(t))) {
        clearSession();
        setAuth(false);
      }
    }, 60_000); // once every minute

    return () => clearInterval(interval);
  }, []);

  if (auth === null) return null;

  if (!auth) {
    return <LoginScreen onAuth={(role) => setAuth({ role })} />;
  }

  return typeof children === 'function'
    ? children({ role: auth.role })
    : children;
};

export default AuthGate;
